export class LabLog {
    labLogId: number;
    logDescription: string;
    logDate: string;
    labLogTypeId: number;
    logFrom:number;  
    logTypeName:string;
    AccountId:number;
    fullName:string;
    roleName:string;
    totalItems: number;
}
